gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
// Event
(function () {
	var unlistenableWindowEvents = {
		click: 1,
		dblclick: 1,
		keyup: 1,
		keypress: 1,
		keydown: 1,
		mousedown: 1,
		mouseup: 1,
		mousemove: 1,
		mouseover: 1,
		mouseenter: 1,
		mouseleave: 1,
		mouseout: 1,
		storage: 1,
		storagecommit: 1,
		textinput: 1
	};

	function indexOf(array, element) {
		var
		index = -1,
		length = array.length;

		while (++index < length) {
			if (index in array && array[index] === element) {
				return index;
			}
		}

		return -1;
	}

	var existingProto = (window.Event && window.Event.prototype) || null;
	window.Event = Window.prototype.Event = function Event(type, eventInitDict) {
		if (!type) {
			throw new Error('Not enough arguments');
		}

		// Shortcut if browser supports createEvent
		if ('createEvent' in document) {
			var event = document.createEvent('Event');
			var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
			var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;

			event.initEvent(type, bubbles, cancelable);

			return event;
		}

		var event = document.createEventObject();

		event.type = type;
		event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
		event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;

		return event;
	};
	if (existingProto) {
		Object.defineProperty(window.Event, 'prototype', {
			configurable: false,
			enumerable: false,
			writable: true,
			value: existingProto
		});
	}

	if (!('createEvent' in document)) {
		window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
			var
			element = this,
			type = arguments[0],
			listener = arguments[1];

			if (element === window && type in unlistenableWindowEvents) {
				throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
			}

			if (!element._events) {
				element._events = {};
			}

			if (!element._events[type]) {
				element._events[type] = function (event) {
					var
					list = element._events[event.type].list,
					events = list.slice(),
					index = -1,
					length = events.length,
					eventElement;

					event.preventDefault = function preventDefault() {
						if (event.cancelable !== false) {
							event.returnValue = false;
						}
					};

					event.stopPropagation = function stopPropagation() {
						event.cancelBubble = true;
					};

					event.stopImmediatePropagation = function stopImmediatePropagation() {
						event.cancelBubble = true;
						event.cancelImmediate = true;
					};

					event.currentTarget = element;
					event.relatedTarget = event.fromElement || null;
					event.target = event.target || event.srcElement || element;
					event.timeStamp = new Date().getTime();

					if (event.clientX) {
						event.pageX = event.clientX + document.documentElement.scrollLeft;
						event.pageY = event.clientY + document.documentElement.scrollTop;
					}

					while (++index < length && !event.cancelImmediate) {
						if (index in events) {
							eventElement = events[index];

							if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') {
								eventElement.call(element, event);
							}
						}
					}
				};

				element._events[type].list = [];

				if (element.attachEvent) {
					element.attachEvent('on' + type, element._events[type]);
				}
			}

			element._events[type].list.push(listener);
		};

		window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
			var
			element = this,
			type = arguments[0],
			listener = arguments[1],
			index;

			if (element._events && element._events[type] && element._events[type].list) {
				index = indexOf(element._events[type].list, listener);

				if (index !== -1) {
					element._events[type].list.splice(index, 1);

					if (!element._events[type].list.length) {
						if (element.detachEvent) {
							element.detachEvent('on' + type, element._events[type]);
						}
						delete element._events[type];
					}
				}
			}
		};

		window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
			if (!arguments.length) {
				throw new Error('Not enough arguments');
			}

			if (!event || typeof event.type !== 'string') {
				throw new Error('DOM Events Exception 0');
			}

			var element = this, type = event.type;

			try {
				if (!event.bubbles) {
					event.cancelBubble = true;

					var cancelBubbleEvent = function (event) {
						event.cancelBubble = true;

						(element || window).detachEvent('on' + type, cancelBubbleEvent);
					};

					this.attachEvent('on' + type, cancelBubbleEvent);
				}

				this.fireEvent('on' + type, event);
			} catch (error) {
				event.target = element;

				do {
					event.currentTarget = element;

					if ('_events' in element && typeof element._events[type] === 'function') {
						element._events[type].call(element, event);
					}

					if (typeof element['on' + type] === 'function') {
						element['on' + type].call(element, event);
					}

					element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
				} while (element && !event.cancelBubble);
			}

			return true;
		};

		// Add the DOMContentLoaded Event
		document.attachEvent('onreadystatechange', function() {
			if (document.readyState === 'complete') {
				document.dispatchEvent(new Event('DOMContentLoaded', {
					bubbles: true
				}));
			}
		});
	}
}());

(function () {

  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

(function() {
  var throttle = function(type, name, obj) {
      obj = obj || window;
      var running = false;
      var func = function() {
          if (running) { return; }
          running = true;
           requestAnimationFrame(function() {
              obj.dispatchEvent(new CustomEvent(name));
              running = false;
          });
      };
      obj.addEventListener(type, func);
  };

  /* init - you can init any event */
  throttle("resize", "optimizedResize");
})();

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

var header = document.getElementById('header');
var hamberger = document.querySelector('.hamberger');
var hamBtn = document.querySelector('.ham-btn');
var gnb = document.getElementById('gnb');

const menuItem = document.querySelectorAll('#top-menu.depth1 > li');
const menuDepth2 = document.querySelectorAll('#top-menu .depth2');
function hide(elem){
  gsap.set(elem, {autoAlpha: 0});
}

menuDepth2.forEach(el=>hide(el));
menuItem.forEach(el=>{
	el.addEventListener("mouseenter",function(event){
		const depth2 = event.target.querySelector('#top-menu .depth2');
    if(depth2){
      gsap.to(depth2,{autoAlpha:1})
    }
		
	});
	el.addEventListener("mouseleave",function(event){
		const depth2 = event.target.querySelector('#top-menu .depth2');
    if(depth2){
      gsap.to(depth2,{autoAlpha:0})
    }
		
	});
})
const menuEvent = function(){
	document.body.classList.toggle('open');
	header.classList.toggle('open');
	this.classList.toggle('open');
	gnb.classList.toggle('open');
	gnb.nextElementSibling.classList.toggle('open');
}
function removeClass(elem,className){
  let max = elem.length;
  for(let i=0;i<max; i++){
    elem[i].classList.remove(className);
  }
}
let clickEvent = (function () {
	if ('ontouchstart' in document.documentElement === true) {
		return 'touchstart';
	} else {
		return 'click';
	}
})();
//클릭 이벤트
hamberger.addEventListener(clickEvent,menuEvent);

let gnbMenu = document.getElementById('menu-main-menu');
gnbMenu.addEventListener(clickEvent,function(e){
  this.tg = e.target;
  this.menuList = this.tg.parentNode;

  if(this.tg.nextElementSibling.classList.contains('gnb-depth2')) {
    e.preventDefault();
    if(this.menuList.classList.contains('active')){
      //클릭한 메뉴에 active가 있을때
      removeClass(gnbMenu,'on');
      this.menuList.classList.remove('active');
      gsap.fromTo(this.menuList,{
          height: this.tg.offsetHeight + this.tg.nextElementSibling.offsetHeight,
        },
        {
          height: this.tg.offsetHeight,
          duration: .6
        });
    } else if(!this.menuList.classList.contains('on')){
      //내가 클릭한 메뉴에 on이 없을때 active가 없을때
      removeClass(gnbMenu,'on');
      this.menuList.classList.add('on');
      gsap.to(this.menuList,
        {
          height: this.tg.offsetHeight + this.tg.nextElementSibling.offsetHeight,
          duration: .6
        });
    } else{
      //클릭한 메뉴에 이미 on이 있을때
      this.menuList.classList.remove('on');
      gsap.to(this.menuList,
        {
          height: this.tg.offsetHeight,
          duration: .6
        });
    }
    
  }

});



var beforeInitSwiper = Array.from(document.querySelectorAll(".main-visual .swiper-slide"));
var pagiCount = beforeInitSwiper.length;
function addPagiLength(){
  const visual = document.getElementsByClassName('main-visual')[0];
  var pagi = document.createElement('span');
  pagi.innerHTML = '/ ' + pagiCount;
  pagi.classList.add('pagi-length');
  visual.appendChild(pagi);
}

var mainVisual = new Swiper('.main-visual', {
	speed: 1000,
	autoplay: {
		delay: 4000,
	},
  parallax: true,
	loop:true,
	navigation: {
		nextEl: '.ctrls.next',
		prevEl: '.ctrls.prev',
	},
	pagination: {
    el: '.swiper-pagination',
    renderBullet: function (index, className) {
      return '<span class="' + className + '"></span>' + '<span class="' + 'pagi-count-' + index + '">'+(index + 1)+'</span>' ;
    },
  },
  on: {
    init: addPagiLength
  },
});


var topSlide = new Swiper('.header-top-slide',{
  direction: 'vertical',
  speed: 600,
	autoplay: {
		delay: 4000,
	},
  loop:true,
});

var interior = new Swiper('.interiorView',{
  effect:'fade',
  autoplay: {
    delay: 4000,
  },
  loop:true,
  pagination: {
    el: '.swiper-pagination.interiorPagi',
    type: 'bullets',
    clickable:true,
  },
  navigation: {
    nextEl: '.ctrlsInterior.next',
    prevEl: '.ctrlsInterior.next',
  },
});


var cleanSlide = new Swiper('.sub2-clean-slide',{
  autoplay: {
    delay: 4000,
  },
  loop:true,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable:true,
  },
  navigation: {
    nextEl: '.ctrls.alt.next',
    prevEl: '.ctrls.alt.prev',
  },
});

var interview = document.getElementById('interview-video');
const interviewVideo = document.getElementById('interviewVimeo');
var interviewVimeo = null;

var options01 = {
  id: 531153754,
  width: 1352,
  //background: true
};

if(interview){
  var $target = document.getElementById('hangul-txt');
  // var $target2 = document.getElementById('hangul-txt2');
  // var $target3 = document.getElementById('hangul-txt3');
  var expandBg = document.getElementsByClassName('expand-bg')[0];

  var tick = false;

  var option = {
    intervalType:50,
    humanize:0.5
  }
  
  ScrollTrigger.create({
    trigger: ".main-video-sect",
    start: "top 20%",
    end: "bottom 50%+=100px",
    onEnter:({progress, direction, isActive}) => {
      $target.classList.add('start');
      if(tick == false){
        TypeHangul.type('#hangul-txt',option);
        tick = true;
      }
    },
    //markers:true
  });

  // $target.addEventListener('th.endType', function (e) {
  //   $target2.classList.add('start');
  //   TypeHangul.type('#hangul-txt2',option);
  // });
  // $target2.addEventListener('th.endType', function (e) {
  //   $target3.classList.add('start');
  //   expandBg.classList.add('start');
  //   TypeHangul.type('#hangul-txt3',option)
  // });
  //$target3.addEventListener('th.endType', function (e) {});
  interviewVimeo = new Vimeo.Player('interviewVimeo', options01);
  interview.addEventListener('mouseover',function(){
    interviewVimeo.play();
    // gsap.to('.interview-tit',{
    //   delay:0.4,
    //   duration:0.6,
    //   autoAlpha:0
    // });
    // gsap.to('.doctor-text',{
    //   delay:0.4,
    //   duration:0.6,
    //   autoAlpha:0
    // });
  });

}

const videoCallBtn = document.getElementById('videoCallBtn');
const videoModal = document.getElementById('videoModal');
const videoCloseBtn = document.getElementById('videoCloseBtn');

if(videoCallBtn){
  videoCallBtn.addEventListener(clickEvent,()=>{
    videoModal.style.display = "block";
  });
  videoCloseBtn.addEventListener(clickEvent,()=>{
    videoModal.style.display = "none";
  })
}




/* Panels */
/* Main navigation */
const visualSect = document.querySelector(".main-visual-sect");
const videoSect = document.querySelector(".main-video-sect");
const profileSect = document.querySelector(".doctor-profile-sect");

if(visualSect){

  var visualHeight = null;
  var videoHeight = null;
  var profileHeight = null;

  const anchors = document.querySelectorAll(".anchor");

  const panelsSection = document.getElementById("subjectPanels");
  const panelsContainer = document.getElementById("subjectPanelsContainer");
  anchors.forEach(anchor => {
    anchor.addEventListener("click", function(e) {
      e.preventDefault();

      const targetElem = document.querySelector(e.target.getAttribute("href"));
      const panel1Left = document.querySelector('#panel-1').offsetLeft;
    
      gsap.to(window, {
        scrollTo: {
          y: visualHeight + videoHeight + profileHeight + targetElem.offsetLeft - panel1Left,
          autoKill: false
        },
        duration: .3
      });
    });
  });

  const panelsTit = document.querySelectorAll(".cure-point-tit-item");
  const panels = gsap.utils.toArray("#subjectPanelsContainer .panel");
  gsap.to(panels, {
    xPercent: -100 * ( panels.length - 1 ),
    ease: "none",
    scrollTrigger: {
      trigger: ".cure-point-sect",
      pin: true,
      start: "top top",
      scrub: 1,
      snap: {
        snapTo: 1 / ( panels.length - 1 ),
        duration: {min: 0.1, max: 0.1}
      },
      onUpdate: self => {
        var activeIndex = Math.round(self.progress * ( panels.length - 1 ));
        panels.forEach((elem,index)=>elem.classList.remove('active'));
        panels[activeIndex].classList.add('active');
        panelsTit.forEach((elem,index)=>elem.classList.remove('active'));
        panelsTit[activeIndex].classList.add('active');
        anchors.forEach((elem,index)=>elem.classList.remove('active'));
        anchors[activeIndex].classList.add('active');
      },
      onSnapComplete: self =>{
        var activeIndex = Math.round(self.progress * ( panels.length - 1 ));
        panels.forEach((elem,index)=>elem.classList.remove('animate'));
        panels[activeIndex].classList.add('animate');
      },
      end: () => "+=" + (panelsContainer.offsetWidth - innerWidth)
    }
  });


  (function () {
    var throttle = function (type, name, obj) {
      obj = obj || window;
      var running = false;
      var func = function () {
        if (running) {
          return;
        }
        running = true;
        requestAnimationFrame(function () {
          obj.dispatchEvent(new CustomEvent(name));
          running = false;
        });
      };
      obj.addEventListener(type, func);
    };

    /* init - you can init any event */
    throttle("resize", "optimizedResize");
  })();

  // handle event
  window.addEventListener("optimizedResize", function() {
    //const width = window.innerWidth;

    visualHeight = parseFloat(getComputedStyle(visualSect, null).height.replace("px", ""))
    videoHeight = parseFloat(getComputedStyle(videoSect, null).height.replace("px", ""))
    profileHeight = parseFloat(getComputedStyle(profileSect, null).height.replace("px", ""))
  });

  window.dispatchEvent(new Event('optimizedResize'));

}

// var naviProgSlide = new Swiper('.navi-prog-slide',{
//   slidesPerView:4,
//   spaceBetween:12,
//   speed: 600,
// 	autoplay: {
// 		delay: 4000,
// 	},
// });


const subNavBar = Array.from(document.getElementsByClassName('sub_navbar'));

ScrollTrigger.matchMedia({
	// desktop
	"(min-width: 769px)": function () {
		// setup animations and ScrollTriggers for screens over 800px wide (desktop) here...
		// ScrollTriggers will be reverted/killed when the media query doesn't match anymore.

    ScrollTrigger.create({
      start: 'top top',
      end: 99999,
      toggleClass: {className: 'plus-top', targets: '.main-header, #gnb'}
    });

    /* Main navigation */
    if(subNavBar){
      subNavBar.forEach((elem,index)=>{
        const panelsSection2 = document.getElementById("panels"+(index+1));
        const panelsContainer2 = document.getElementById("panels-container"+(index+1));
        const navAnchor = document.querySelectorAll("#subNavList"+(index+1)+">li>a");

        ScrollTrigger.create({
          trigger: elem,
          start: 'top 48',
          end: 99999,
          toggleClass: {className: 'fixed-nav', targets: elem}
        });

        navAnchor.forEach(anchor => {
          anchor.addEventListener("click", function(e) {
            e.preventDefault();
    
            const targetElem = document.querySelector(e.target.getAttribute("href"));
            if(targetElem && panelsContainer2.isSameNode(targetElem.parentElement)) {
              const containerOffset = panelsSection2.offsetTop + targetElem.offsetLeft;
    
              gsap.to(window, {
                scrollTo: {
                  y: containerOffset,
                  autoKill: false
                },
                duration: .6
              });
            } else {
              gsap.to(window, {
                scrollTo: {
                  y: targetElem,
                  autoKill: false
                },
                duration: .6
              });
            }
          });
        });

        /* Panels */
        const panels2 = gsap.utils.toArray("#panels-container"+(index+1) + " .panel");
        gsap.to(panels2, {
          xPercent: -100 * ( panels2.length - 1 ),
          ease: "none",
          scrollTrigger: {
            trigger: "#panels-container"+(index+1),
            pin: true,
            start: "top top",
            scrub: 1,
            snap: {
              snapTo: 1 / ( panels2.length - 1 ),
              duration: {min: 0.1, max: 0.1}
            },
            onUpdate: self => {
              var activeIndex = Math.round(self.progress * ( panels2.length - 1 ));
              panels2.forEach((elem,index)=>elem.classList.remove('active'));
              panels2[activeIndex].classList.add('active');
              navAnchor.forEach((elem,index)=>elem.parentNode.classList.remove('active'));
              navAnchor[activeIndex].parentNode.classList.add('active');
            },
            onSnapComplete: self =>{
              var activeIndex = Math.round(self.progress * ( panels2.length - 1 ));
              panels2.forEach((elem,index)=>elem.classList.remove('animate'));
              panels2[activeIndex].classList.add('animate');
            },
            end: () => "+=" + (panelsContainer2.offsetWidth - innerWidth)
          }
        });
      });
    }
    
	},
	// mobile
	"(max-width:768px)": function () {
		// Any ScrollTriggers created inside these functions are segregated and get
		// reverted/killed when the media query doesn't match anymore.
    // const showAnim = gsap.from('.main-header', { 
    //   yPercent: -100,
    //   paused: true,
    //   duration: 0.2
    // }).progress(1);

    // ScrollTrigger.create({
    //   start: 'top -63',
    //   end: 99999,
    //   onUpdate: (self) => {
    //     self.direction === -1 ? showAnim.play() : showAnim.reverse()
    //   },
    //   toggleClass: {className: 'plus-top', targets: '.main-header, #gnb'}
    // });

    /* Main navigation */
    

    if(subNavBar){
      
      subNavBar.forEach((elem,index)=>{
        const panelsSection2 = document.getElementById("panels"+(index+1));
        const panelsContainer2 = document.getElementById("panels-container"+(index+1));
        const navAnchor = document.querySelectorAll("#subNavList"+(index+1)+">li>a");

        ScrollTrigger.create({
          trigger: elem,
          start: 'top 60',
          end: 99999,
          toggleClass: {className: 'fixed-nav', targets: elem}
        });

        navAnchor.forEach((anchor,index) => {
          anchor.addEventListener("click", function(e) {
            e.preventDefault();
            const targetElem = document.querySelector(e.target.getAttribute("href"));
            gsap.to(window, {
              scrollTo: {
                y: targetElem,
                autoKill: false
              },
              duration: .6
            });
            
          });
        });
  
        /* Panels */
        const panels2 = gsap.utils.toArray("#panels-container"+(index+1) + " .panel");
        panels2.forEach((panel,index)=>{
          gsap.to(panel, {
            scrollTrigger: {
              trigger: panel,
              start: "top 2",
              end:"bottom 2",
              onEnter:()=>{
                gsap.to(elem, {duration: .2, scrollTo: {x: (navAnchor[index].offsetLeft)/2}});
              },
              onEnterBack:()=>{
                gsap.to(elem, {duration: .2, scrollTo: {x: (navAnchor[index].offsetLeft)/2}});
              },
              toggleClass: {targets: navAnchor[index].parentNode, className: "active"}
            }
          });
        })
      });
  
      

    }
    
	},
	// all 
	"all": function () {
    // ScrollTriggers created here aren't associated with a particular media query,
		// so they persist.
    const bgChange = document.getElementById('bgChange');
    if(bgChange){
      gsap.to(bgChange, { 
        backgroundColor:'#000',
        duration: 0.8,
        scrollTrigger:{
          trigger: bgChange,
          start: 'top 30%',
          end: 'bottom top',
          toggleActions:'play pause resume reset',
          toggleClass: {className: 'bg-changed', targets: '#bgChange'}
        }
      });
  
    }

    const changeGif = document.querySelector('.change-gif');
    
    if(changeGif){
      const steps = Array.from(document.getElementsByClassName('clean-sys-step'));
      var timer = setInterval(function(){
        steps.forEach(step=>step.classList.remove('active'));
        steps[dIdx].classList.add('active');
        dIdx++;
        if(dIdx == dEnd){
            dIdx = 0;
        }
      },3000);
      var dIdx = 1,
          dEnd = steps.length;


      ScrollTrigger.create({
        trigger: changeGif,
        start: 'top 30%',
        end: 'bottom top',
        //toggleActions:'play pause resume reset',
        onEnter:()=>timer
      });
    }


    const lineAni = document.getElementsByClassName("headline");
    if(lineAni){
      gsap.utils.toArray(lineAni).forEach(function(elem, index){
        const txtrow = elem.querySelectorAll('.text-row');
        
        txtrow.forEach((el, i)=>{
          const txt = el.querySelector('span');
          gsap.fromTo(txt,{
            yPercent:100,
          },{
            scrollTrigger: {
              trigger: elem,
              start: 'top 66%',
              toggleActions: 'play none none none',
              //markers:true
            },
            yPercent:0,
            duration:.6,
            delay:.2*i,
            ease: Back.easeOut,
          })
        });
        
      });
    }/* headline이 있을때만 실행 */

    gsap.utils.toArray(".parallax").forEach((section, i) => {
      section.bg = section.querySelector(".bg");
      let elemHeight = section.bg.clientHeight;
      section.bg.style.backgroundPosition = "50% 0px"; 
        gsap.to(section.bg, {
          backgroundPosition: `50% ${elemHeight / 2}px`,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top 100", 
            end: "bottom top",
            scrub: true
          }
        });
    });

    ScrollTrigger.create({
      trigger: '.sub_link_nav',
      start: 'top 48',
      end: 99999,
      toggleClass: {className: 'fixed-nav', targets: '.sub_link_nav'}
    });

    const subLinkNav = document.querySelectorAll(".sub_link_nav__list .anchor");
    if(subLinkNav){
      const subLinkPanel = document.querySelectorAll("[id^=cavity]");
  
      subLinkNav.forEach(function(a,idx) {
        a.addEventListener("click", function(e) {
          e.preventDefault();
          gsap.to(window, {duration: 1, scrollTo: e.target.getAttribute("href")});
        });
        
      });

      subLinkPanel.forEach(function(anchorPanel,idx){

        /* Panels */
        gsap.to(anchorPanel, {
          scrollTrigger: {
            trigger: anchorPanel,
            start: "top 2",
            end:"bottom 2",
            onEnter:()=>{
              subLinkNav.forEach((a)=>a.parentNode.classList.remove('active'));
              subLinkNav[idx].parentNode.classList.add('active');
            },
            onEnterBack:()=>{
              subLinkNav.forEach((a)=>a.parentNode.classList.remove('active'));
              subLinkNav[idx].parentNode.classList.add('active');
            },
            //toggleClass: {targets: anchorPanel, className: "active"}
          }
        });

      });

    }
    

  }
});